<template>
  <ob-admin-section
    type="cifuri"
    :xlsx="true"
    :xlsxdown="true"
    :confirm-value="confirm.dialog"
    @confirmed="_cbConfirmed">
    <template slot="section-title">Sectiune CIF-uri si Proprietati</template>
    <template slot="toolbar-title">Baza de date Autoritati Publice Locale</template>
    <template slot="fab">
      <v-speed-dial
        class="ob-speed-dial"
        v-model="fab"
        absolute
        fixed
        bottom
        right
        direction="top"
        open-on-hover
        transition="scroll-y-reverse-transition"
        key="speeddial">
        <v-btn
          slot="activator"
          v-model="fab"
          color="accent"
          dark
          fab
          key="speed">
          <v-icon>mdi-menu</v-icon>
          <v-icon>mdi-close</v-icon>
        </v-btn>

        <v-tooltip left>
          <span slot="activator">
            <v-btn
              fab
              small
              color="success"
              @click="_cbAddPerioada">
              <v-icon>mdi-calendar-plus</v-icon>
            </v-btn>
          </span>
          <span>Adauga perioada noua</span>
        </v-tooltip>
        <v-tooltip left>
          <span slot="activator">
            <v-btn
              :disabled="!tabs.length"
              fab
              small
              color="info"
              @click="_cbEditPerioada">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </span>
          <span>Modifica perioada curenta</span>
        </v-tooltip>
        <v-tooltip left>
          <span slot="activator">
            <v-btn
              :disabled="!tabs.length"
              fab
              small
              color="error"
              @click="_cbDeletePerioada">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </span>
          <span>Sterge perioada curenta</span>
        </v-tooltip>
      </v-speed-dial>
    </template>
    <template slot="dialogs">
      <ob-dialog :value="perioada.dialog" :max-width="500" @close="_cbClosePerioadaDialog" key="perioada">
        <template slot="title">
          {{this.perioada.type === 'add' ? 'Adauga o noua perioada' : 'Modifica perioada curenta'}}
        </template>
        <template slot="content">
          <v-alert :value="true" type="info">
            Daca alegeti importarea datelor de la perioada precedenta se vor copia datele si pentru: clasificatie, indicatori, verificare.
            Daca se alege descarcarea datelor de la MF se va porni si descarcarea automata a fisierelor ce contin executiile la perioada.

            Bifarea ambelor optiuni este identica cu pornirea unei sesiuni de automatizare.
          </v-alert>
          <form ref="perioadaForm">
            <v-date-picker
              v-model="perioada.values.quarter"
              :allowed-dates="allowedMonths"
              type="month"
              full-width
              locale="ro-RO"
              :show-current="latestPerioada"
              :title-date-format="dateToQuarter"
              :events="['2018-12-01']"
              class="mt-3 elevation-0">
            </v-date-picker>
            <v-switch
              color="primary"
              label="Se importa datele din perioada precedenta?"
              v-model="perioada.values.preluare"
              hide-details
              v-if="perioada.type === 'add'">
            </v-switch>
            <v-switch
              color="primary"
              label="Se porneste automatizarea descarcarii executiilor, citirii fisierelor, calcului clasificatiei si generarii rapoartelor?"
              v-model="perioada.values.automation"
              hide-details
              v-if="perioada.type === 'add'">
            </v-switch>
          </form>
        </template>
        <template slot="actions">
          <v-spacer></v-spacer>
          <v-btn flat @click="_cbClosePerioadaDialog">Anulare</v-btn>
          <v-btn flat color="primary" @click="_cbSavePerioada" :disabled="!perioada.values.quarter">Salveaza</v-btn>
        </template>
      </ob-dialog>
    </template>

    <template slot="ob-row-expansion" slot-scope="{cifItem, perioada}">
      <ob-rapoarte-cif :cifItem="cifItem" :perioada="perioada"></ob-rapoarte-cif>
    </template>
  </ob-admin-section>
</template>

<script>
import AdminSection from '@/components/AdminSection'
import Dialog from '@/components/Dialog'

import RapoarteCif from '@/components/RapoarteCif'

export default {
  name: 'cifuri',
  components: {
    'ob-admin-section': AdminSection,
    'ob-dialog': Dialog,
    'ob-rapoarte-cif': RapoarteCif
  },
  data: () => ({
    type: 'cifuri',
    fab: null,
    perioada: {
      dialog: false,
      type: 'add',
      values: {
        quarter: null,
        preluare: false,
        automation: false
      }
    },
    confirm: {
      dialog: false,
      callback: null
    }
  }),
  computed: {
    tabs () {
      return this.$store.getters[`${this.type}/tabs`]
    },
    selectedTab () {
      return this.$store.getters[`${this.type}/selectedTab`]
    },
    selectedTabID () {
      return this.$store.getters[`${this.type}/selectedTabID`]
    },
    latestPerioada () {
      return this.$store.getters[`${this.type}/latestPerioada`]
    }
  },
  methods: {
    _cbAddPerioada () {
      this.openPerioadaDialog()
      this.perioada.type = 'add'
    },
    _cbClosePerioadaDialog () {
      this.perioada.dialog = false
      this.$set(this.perioada.values, 'quarter', null)
      this.$set(this.perioada.values, 'preluare', false)
      this.$set(this.perioada.values, 'automation', false)
      this.$set(this.perioada, 'type', null)
    },
    _cbConfirmed (value) {
      if (value && this.confirm.callback) this[this.confirm.callback]()
      this.confirm.dialog = false
      this.confirm.callback = null
    },
    _cbDeletePerioada () {
      this.perioada.type = 'delete'
      this.confirm.dialog = true
      this.confirm.callback = '_cbSavePerioada'
    },
    _cbEditPerioada () {
      const parts = this.tabs[this.selectedTab].label.split('-')
      const year = parts[0]
      const quarter = +parts[1][1] * 3
      this.perioada.values.quarter = `${year}-0${quarter}`
      this.perioada.type = 'edit'
      this.openPerioadaDialog()
    },
    _cbSavePerioada () {
      switch (this.perioada.type) {
        case 'add': {
          const parts = this.perioada.values.quarter.split('-')
          const year = parts[0]
          const quarter = Math.ceil(((+parts[1]) / 3))

          this.$store.dispatch(`${this.type}/savePerioada`, {
            label: `${year}-T${quarter}`,
            date: `${this.perioada.values.quarter}-01`,
            preluare: this.perioada.values.preluare,
            automation: this.perioada.values.automation
          })

          break
        }
        case 'edit': {
          const parts = this.perioada.values.quarter.split('-')
          const year = parts[0]
          const quarter = Math.ceil(((+parts[1]) / 3))

          this.$store.dispatch(`${this.type}/editPerioada`, {
            label: `${year}-T${quarter}`,
            date: `${this.perioada.values.quarter}-01`
          })

          break
        }
        case 'delete': {
          this.$store.dispatch(`${this.type}/deletePerioada`, this.selectedTabID)
          break
        }
      }
      this._cbClosePerioadaDialog()
    },

    allowedMonths (val) {
      const parts = val.split('-')
      const isAllowedMonth = parseInt(parts[1], 10) % 3 === 0
      const quarter = (Math.floor((+parts[1] - 1) / 3)) + 1
      const formatted = `${parts[0]}-T${quarter}`
      let duplicate = this.tabs.find((perioada, index) => {
        if (this.perioada.type === 'edit' && index === this.selectedTab) return false
        return perioada.label === formatted
      })

      return isAllowedMonth && !duplicate
    },
    dateToQuarter (date) {
      const month = date.split('-')[1]
      return `Trimestrul ${(+month / 3)}`
    },
    openPerioadaDialog () {
      this.perioada.dialog = true
    }
  },
  created () {
    this.$store.dispatch('cifuri/setEventWatchers')
    this.$store.dispatch('cifuri/fetchTabs')
    this.$store.dispatch('cifuri/fetchHeaders')
    this.$store.dispatch('cifuri/fetchItems')
  }
}
</script>

<style>

</style>
